const waitForEl = function(selector, callback, maxtries, interval) {
  maxtries = maxtries || false; 
  interval = interval || 100;
  var poller = setInterval(function() {
    var el = jQuery(selector)
    var retry = maxtries === false || maxtries-- > 0
    if (retry && el.length < 1) return // will try again
    clearInterval(poller)
    callback(el || null)
  }, interval)
}

function isPreorder(product) {
  return product?.tags?.includes('preorder') || product?.tags?.includes('pre-order')
}

const badges = {
	'popular-gift': {
		icon: `<?xml version="1.0" encoding="UTF-8"?>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96.7 99.77">
  <defs>
    <style>
      .cls-1 {
        fill: currentColor;
        stroke-width: 0px;
      }
    </style>
  </defs>
  <path class="cls-1" d="M89.56,99.77H7.14c-3.94,0-7.14-3.2-7.14-7.14v-58.82c0-3.94,3.2-7.14,7.14-7.14h82.43c3.93,0,7.14,3.2,7.14,7.14v58.82c0,3.94-3.2,7.14-7.14,7.14ZM7.14,30.12c-2.04,0-3.69,1.66-3.69,3.69v58.82c0,2.04,1.66,3.69,3.69,3.69h82.43c2.04,0,3.69-1.66,3.69-3.69v-58.82c0-2.04-1.66-3.69-3.69-3.69H7.14Z"/>
  <path class="cls-1" d="M45.58,30.18c-15.41,0-29.84-13.27-30.69-22-.43-4.37,2.45-7.37,7.69-8.02,21.5-2.65,26.43,27.66,26.48,27.97.07.48-.06.96-.35,1.34s-.74.61-1.22.64c-.63.05-1.27.07-1.9.07ZM25.11,3.45c-.68,0-1.38.04-2.11.13-5.04.62-4.78,3.36-4.69,4.26.64,6.53,13.25,18.71,26.95,18.89-1.34-5.89-6.45-23.29-20.16-23.29Z"/>
  <path class="cls-1" d="M49.13,30.18c-.63,0-1.27-.02-1.9-.07-.48-.03-.92-.27-1.22-.64s-.43-.86-.35-1.34c.05-.31,5.03-30.61,26.48-27.97,5.25.65,8.12,3.64,7.69,8.02-.85,8.73-15.28,22-30.69,22ZM69.6,3.45c-13.71,0-18.82,17.39-20.16,23.29,13.7-.18,26.31-12.36,26.95-18.89.09-.9.36-3.64-4.69-4.26-.72-.09-1.43-.13-2.11-.13Z"/>
  <path class="cls-1" d="M94.98,46.48h-37.95c-.95,0-1.72-.77-1.72-1.72s.77-1.72,1.72-1.72h37.95c.95,0,1.72.77,1.72,1.72s-.77,1.72-1.72,1.72Z"/>
  <path class="cls-1" d="M37.7,46.48H1.72C.77,46.48,0,45.71,0,44.76s.77-1.72,1.72-1.72h35.97c.95,0,1.72.77,1.72,1.72s-.77,1.72-1.72,1.72Z"/>
  <path class="cls-1" d="M57.02,99.77h-19.34c-.95,0-1.72-.77-1.72-1.72V28.46c0-.95.77-1.72,1.72-1.72h19.34c.95,0,1.72.77,1.72,1.72v69.59c0,.95-.77,1.72-1.72,1.72ZM39.41,96.33h15.89V30.18h-15.89v66.15Z"/>
</svg>`,
		label: 'Popular Gift',
		color: 'red',
	},
	'new-stuff': {
		label: 'New',
	},
};


class ProductParent {
constructor(container) {
  this.container = container;
  this.collectionHandle = this.container.getAttribute('data-collection-handle')
  this.$submitBtn = $('#add-to-cart-variant-button');
  this.savedWishList = {};
  // Only update the URL query params when we're ready, e.g. a user clicks
  this.updateUrlAllowed = false;
  this.getProductData((data) => {
      this.tabs = data.tabs;
      this.variants = data.variants;
      let currentVariantId = this.getUrlParameter("variant");
      let group = this.getUrlParameter("group");        
      if (currentVariantId) {
          this.selectedVariant = Object.values(this.variants).find(
              variant => variant.id.toString() === currentVariantId.toString()
          );
          // only select variants that have images and are available.
          if (this.selectedVariant) {
              var swatch = this.tabs[this.selectedVariant.tab].swatches[this.selectedVariant.swatch]
              if (swatch.images.length === 0 || !swatch.available) {
                  this.selectedVariant = null;
              }
          }
      } else if (group) {
          this.selectedGroup = group;
      }
      this.buildPage();
      if (this.selectedVariant) {
          window.scrollToSwatch(this.getSwatchSlug(this.selectedVariant.swatch));
      }
      this.injectSearchspringWidgets(this.selectedVariant?.sku)
  })
  this.addListeners();

  // First in-stock variant
  this.firstInStockVariant = null;
}

buildPage() {
  this.setFabricContent();
  var that = this;
  var length = 0;
  Object.values(this.tabs).forEach((tab, index) => {
      var $tab = $(`
          <button
              type="button"
              color-tab-opener="${tab.handle}"
              class="color-swatch__tab-opener">
              ${tab.name}
          </button>
      `)
      length++;
      $('#swatch-tabs').append($tab);
      // Check if NOT deeped linked to a variant or Group:
      // select the first tab (index 0)
      if (index === 0 && !this.selectedVariant && !this.selectedGroup) {
          this.updateTab(tab.handle)
      // Check if not deeped linked to a variant or Group:
      } else if (this.selectedVariant && this.selectedVariant.tab === tab.handle) {
          this.updateTab(tab.handle)
      } else if (this.selectedGroup) {
          this.updateTab(this.selectedGroup)
      }
      $tab.click(function(event) {
          var $this = $(this); //clicked on tab opener
          event.stopPropagation();
          that.selectedVariant = null;
          var tabHandle = $this.attr('color-tab-opener'); //current color grouping ID
          //that.openTab(tabId, true)
          that.updateTab(tabHandle);
      });
  })
  // Hide the tabs if there is only one tab
  if (length <= 1) {
      $('#swatch-tabs').hide();
      $('.color-swatch__tab-header').hide();
  }
  this.checkModelSizeFit();
  this.listCategories();
  this.adjustForPreorder();
  this.checkExclusions();
  this.checkEcommerceExclusives();
  this.checkDelayedShipping();
  this.checkWishlist();
  this.checkBadges();
}

updateTab(tabHandle, clickFirstSwatch) {
    if (!this.tabs[tabHandle]) {
        return
    }
  $('.color-swatch__tab-opener').removeClass('active');
  $(`.color-swatch__tab-opener[color-tab-opener="${tabHandle}"]`).addClass('active');
  this.makeSizes(Object.values(this.tabs[tabHandle].sizes));
  this.showSwatches(this.tabs[tabHandle].swatches, tabHandle);
  this.initTipsyForSwatches()



  // get current variant id
  var regex = new RegExp("[\\?&]variant=([^&#]*)");
  var results = regex.exec(location.search);
  if(results !== null || this.selectedVariant.id) {
    var currentVariantId = results ? decodeURIComponent(results[1].replace(/\+/g, " ")) : this.selectedVariant.id;
    
    // Update variant_id input
    var variantIdInput = $('.variant_id');
    
    if (variantIdInput.length) {
      variantIdInput.val(currentVariantId);
    }

    // update fabric badge
    var fabricBadgeClass = '.surf-features_fabric--' + currentVariantId;
    $('.surf-features_fabric').hide();
    $(fabricBadgeClass).show();
    
    // reset inventory message
    var inventory_item = $('.inventory-container').find("[data-id='" + currentVariantId + "']");
    var inventoryDiv = $(inventory_item[0]).clone();
    $('.inventory-alternate').html(inventoryDiv);

    /**
    * update collection level promo message
    */

    // hide collection level promo bar
    $('.promo_message_container').hide();
    $('.promo_message_container .promo_message_1').hide();
    $('.promo_message_container .promo_message_2').hide();
    $('.promo_message_container .promo_message_3').hide();

    if(window.promoMessageArray[0].includes(currentVariantId)) {
      $('.promo_message_container .promo_message_1').show();
      $('.promo_message_container').show();
    }

    if(window.promoMessageArray[1].includes(currentVariantId)) {
      $('.promo_message_container .promo_message_2').show();
      $('.promo_message_container').show();
    }

    if(window.promoMessageArray[2].includes(currentVariantId)) {
      $('.promo_message_container .promo_message_3').show();
      $('.promo_message_container').show();
    }

    /**
    * update child product level final sale badge
    */
    var isFinalSale = $('.final-sale-badge-data-wrapper').find("[data-id='" + currentVariantId + "']");
    isFinalSale = isFinalSale.data('final-sale') == true;

    if (isFinalSale) {
      $('.product-final-sale').show();
    } else {
      $('.product-final-sale').hide();
    }
  } else {
    // update fabric badge
    var firstVariantID = this.selectedVariant.id;
    var fabricBadgeClass = '.surf-features_fabric--' + firstVariantID;
    $('.surf-features_fabric').hide();
    $(fabricBadgeClass).show();
  }

  // update print collection
  var $selectedSwatchInput = $("input[name='color-input']:checked");
  var $selectedSwatchInputColor = $selectedSwatchInput.val();

  //---------remove print collection content
  $('.product-print-collection__wrapper').hide();
  $('.product-print-collection-body').owlCarousel('destroy');
  $('.product-print-collection-body').empty();

  if(window.print_products) {
    var print_product_limit = 4;
    var iterator = 1;

    //---------draw print collection content
    window.print_products.every(function(print_product) {
      if(iterator > print_product_limit) {
        return false;
      }
      
      print_product_slug = print_product.slug;

      print_product.variants.every(function(variant) {
        if(variant.option1 == $selectedSwatchInputColor && variant.id != currentVariantId) {
          iterator ++;

          var productLink = '/products/' + print_product_slug + '?variant=' + variant.id;

          $('.product-print-collection-body').append(`
            <div class="product-print-collection_item">
              <a href="${productLink}">
                <div class="product-print-collection_item_image" style="background-image: url(${Shopify.resizeImage(variant.featured_image_src, "x200")})"></div>
                
                <div class="product-print-collection_item_content">
                  <div class="product-print-collection_item_title">
                    ${print_product.title}
                  </div>

                  <div class="product-print-collection_item_price">
                    ${Shopify.formatMoney(variant.price)}
                  </div>
                </div>
              </a>
            </div>
          `);

          $('.product-print-collection__wrapper').show();

          return false;
        }

        return true;
      });

      return true;
    });

    var owlConfig = {
      items: 4,
      autoWidth: false,
      lazyLoad: true,
      loop: true,
      margin: 30,
      nav: true,
      dots: false,
      responsive: {
        0: {
          items: 1
        },
        375: {
          items: 2,
          margin: 60
        },
        767: {
          items: 3
        },
        992: {
          items: 4
        }
      }
    };

    $('.product-print-collection-body').owlCarousel(owlConfig);
  }
}

showSwatches(swatches, tabHandle) {
  var $group = $('#swatch-container')
  $group.empty();
  
  Object.values(swatches)
      .filter(s => { if (s.available && s.images.length > 0) return true })
      .forEach((swatch, index) => {
          
      $group.append($(`
      <li id="swatch-container-${this.getSwatchSlug(swatch.name)}" in-stock="available" class="swatch-element color solids ${this.getSwatchSlug(swatch.name)} available" originating-product="Fendrick Top - Lights" data-value="${swatch.name}" data-price="$32.00" data-variant="37970412865">
        <input id="swatch-${this.getSwatchSlug(swatch.name)}" type="radio" name="color-input" value="${swatch.name}" data-swatch-tab="${tabHandle}">
        <label for="swatch-${this.getSwatchSlug(swatch.name)}" rel="tipsy" original-title="${swatch.name}">
            <span class="offscreen">${swatch.name}</span>
        </label>
        ${swatch.isOnSale ? '<span class="swatch__sale-icon" aria-label="Sale Icon">Sale</span>' : ''}
      </li>
      `))
      // TODO: add deep linking check here
      if (index === 0 && !this.selectedVariant) {
          $(`#swatch-${this.getSwatchSlug(swatch.name)}`).prop( "checked", true );

          // this.firstInStockVariant = "no-variant";

          this.checkSwatches()
      } else if (this.selectedVariant && this.selectedVariant.swatch === swatch.name) {
          $(`#swatch-${this.getSwatchSlug(swatch.name)}`).prop( "checked", true );
          this.checkSwatches();
          this.updateCarousel();
          this.showTeammatesFlag();
      }
  })
  const $swatches = $('li.swatch-element.color');
  this.applySwatches($swatches, 'label');
}

initTipsyForSwatches() {
    if($('[rel=tipsy]').tipsy) {
      $('[rel=tipsy]').tipsy({gravity: 's'});
    }
}

applySwatches(swatches, applyToSelector) {
  swatches.each(function(index, swatch) {
    const swatchColorAttribute = swatch.dataset.value;
    const swatchColors = swatchColorAttribute.split(' & ');

    const swatchHexes = swatchColors.map(function(name) {
      return colors[name] || '#fff';
    });

    let bg;

    if (swatchHexes.length === 1) {
      bg = swatchHexes[0];
    } else if (swatchHexes.length === 2) {
      bg = `linear-gradient(135deg, ${swatchHexes[0]} 50%, ${swatchHexes[1]} 50%)`;
    } else if (swatchHexes.length === 3) {
      bg = `linear-gradient(135deg, ${swatchHexes[0]} 40%, ${swatchHexes[1]} 40%, ${swatchHexes[1]} 60%, ${swatchHexes[2]} 60%)`;
    }

    $(swatch).find(applyToSelector).css('background', bg);
  });

  var $selectedSizeInput = $("input[name='size-input']:checked");
  var selectedSize = $selectedSizeInput.val();

  // set unavailalbe colors with selected size
  this.setUnavailableColorsWithSize(selectedSize);
}

checkSwatches() {
    // get current swatch


    var $selectedSwatchInput = $("input[name='color-input']:checked");
    var selectedSwatchColor = $selectedSwatchInput.val();
    var selectedSwatchTab = $selectedSwatchInput.data('swatch-tab');
    var $selectedSizeInput = $("input[name='size-input']:checked")
    var selectedSize = $selectedSizeInput.val();
    var tab = this.tabs[selectedSwatchTab];
    this.selectedSize = selectedSize;
    var previousSwatchName = (this.selectedVariant) ? this.selectedVariant.swatch : null
    this.selectedVariant = null;
    var $addToCartBtn = $(".add-to-cart.add-to-cart-button");
    if (selectedSize && selectedSwatchColor) {
      
      this.selectedVariant = this.variants[`${selectedSwatchColor}-${selectedSize}`];
      // unavailable === variant + size combo doesn't exist
      var unavailable = false;
      var swatchVariants;
      if (!this.selectedVariant) {
          unavailable = true;
          swatchVariants = this.getSwatchVariants(selectedSwatchTab, selectedSwatchColor);
          swatchVariants.forEach(sw => {
              if (sw && !this.selectedVariant) {
                  this.selectedVariant = sw;
              }
          });
      }

      swatchVariants = this.getSwatchVariants(selectedSwatchTab, this.selectedVariant.swatch);
      $addToCartBtn.attr("variant-id", this.selectedVariant.id);
      var $priceIndicator = $("span.price-item.price-item--regular");
      this.$submitBtn.prop( "disabled", false);

      this.$submitBtn.attr('value', 'Add to Cart');

      $(".notify-restock-container").hide();
      
      $('#size-container li').addClass('soldout');
      swatchVariants.forEach(swatch => {
          if (!swatch) {
              return;
          }
          if (swatch.available) {
              $(`#size-container-${this.getSwatchSlug(swatch.size)}`).removeClass('soldout');
              
              // Set first in-stock variant
              if (this.firstInStockVariant == null && this.firstInStockVariant != "no-variant") {
                $(`#swatch-${this.getSwatchSlug(swatch.size)}`).trigger('click');
                this.firstInStockVariant = `#swatch-${this.getSwatchSlug(swatch.size)}`;
              }
          } else {
              $(`#size-container-${this.getSwatchSlug(swatch.size)}`).addClass('soldout');
              if (selectedSize === swatch.size) {
                  this.$submitBtn.hide();
                  $("#add-to-cart-sticky-header-button").hide();
                  $(".notify-button").show();
                  $(".notify-button-wrapper").show();
                  $(".notify-restock-container").show();
              }
          } 
      });

      if (unavailable) {
        setTimeout(() => {
          this.$submitBtn.hide();
          $(".notify-button").show();
          $(".notify-button-wrapper").show();
        }, 0)
      } else if (this.selectedVariant.available) {
          this.$submitBtn.show();
          $("#add-to-cart-sticky-header-button").css('display', 'inline-block');
          $(".notify-button").hide();
          $(".notify-button-wrapper").hide();
      }

      if (this.selectedVariant.isOnSale) {
          $priceIndicator.html(this.getSaleLabel('$' + this.selectedVariant.price, '$' + this.selectedVariant.oldPrice));
      } else {
          $priceIndicator.html('$' + this.selectedVariant.price);
      }
      if (previousSwatchName !== this.selectedVariant.swatch) {
          this.updateCarousel();
          this.showTeammatesFlag();
      }
      $('.product-details.panel > .inner-panel').html(this.selectedVariant.product.body_html)
      var pageUrl = `?variant=${this.selectedVariant.id}`;
      if (this.updateUrlAllowed) {
          window.history.replaceState('', '', pageUrl);
      }
    }
    $('#swatch-indicator').text(selectedSwatchColor);
    $('#size-indicator').text(selectedSize);      

    // set unavailalbe colors with selected size
    this.setUnavailableColorsWithSize(selectedSize);
    this.injectSearchspringWidgets(this.selectedVariant?.sku)
}

injectSearchspringWidgets(sku) {
  const container = document.getElementById('searchspring-widgets-container');
  if (container) {
    container.replaceChildren();
    const profiles = ['similar', 'cross-sell'];
    profiles.forEach(profile => {
      const script = document.createElement('script');
      script.type = 'searchspring/personalized-recommendations';
      script.setAttribute('profile', profile);
      script.textContent = `seed = "${sku}";`;
      document.getElementById('searchspring-widgets-container').appendChild(script);
    });
  }
}

getSwatchVariants(tabName, swatchName) {
  var sizes = this.tabs[tabName].sizes;
  var variants = []
  Object.values(sizes).forEach(size => {
      variants.push(
          this.variants[`${swatchName}-${size.name}`]
      )
  })
  return variants
}

setUnavailableColorsWithSize(selectedSize) {
  var variants = this.variants; // all varaints in the product page
  var availableArray = {};  // array object for storing stock availability

  // Loop through all products and find the variants with the selected size
  Object.entries(variants).forEach(function(item) {
    var key = item[0];  // Color-Size pair
    var value = item[1];  // Variant data

    var variantColor = key.split('-')[0]; // variant color
    var variantSize = key.split('-')[1];  // variant size
    
    // check if the variant is selected size
    if(variantSize == selectedSize) {
      // store availability to availableArray
      availableArray[variantColor] = value.available || isPreorder(value.product);
    }
  });

  //Loop through all color elements and grey out the unavailalbe colors
  $('#swatch-container li').each(function(index, item) {
    var itemColor = $(item).data('value');

    if(itemColor in availableArray) {
      if(availableArray[itemColor]) {
        // set available
        $(this).css('opacity', '1');
        $(this).removeClass('currently-unavailable');
      } else {
        // set unavailable
        $(this).css('opacity', '0.4');
        $(this).addClass('currently-unavailable');
      }
    } else {  // technically, there's no case ...
      // set available
      $(this).css('opacity', '1');
      $(this).removeClass('currently-unavailable');
    }
  });
}

makeSizes(sizes) {
      $container = $('#size-container');
      $container.empty();
      var letterVariants = sizes.filter(size => /[a-zA-Z]/gi.test(size.name))
      letterVariants.concat(sizes.filter(size => !(/[a-zA-Z]/gi.test(size.name))))
      .forEach((size, index) => {
          let handle = this.getSwatchSlug(size.name);
          let $size = $(`
          <li id="size-container-${handle}" class="swatch-element size ${size.name} available" data-value="${size.name}">
              <input id="swatch-${handle}" type="radio" name="size-input" value="${size.name}">
              <label for="swatch-${handle}">
                  ${size.name}
                  <span class="crossed-out" title="Not available in this option"></span>
              </label>
          </li>
          `)
          $container.append($size);
          if (this.selectedVariant && this.selectedVariant.size === size.name) {
              $(`#swatch-${handle}`).prop( "checked", true );
          } else if (this.selectedSize === size.name || (index === 0 && !this.selectedSize)) {
              $(`#swatch-${handle}`).prop( "checked", true );
          }
      })
}

getProductData(callback) {
  $.ajax({
      method: 'GET',
      url: '/collections/' + this.collectionHandle + '/products.json?limit=250'
  }).then(function(res) {
      var data = {};
      var variants = {}
      var swatches = []
      res.products.forEach(product => {
          product.variants.forEach(v => {
              v.options = []
              if (v.option1) {
                  v.options.push(v.option1);
              }
              if (v.option2) {
                  v.options.push(v.option2);
              }
              if (v.option3) {
                  v.options.push(v.option3);
              }
              v.public_title = `${v.option1}  / ${v.option2}`;
              v.name = `${product.title} - ${v.public_title}`;
              // if it's sold out, need these data points for the BIS plugin
              v.inventory_quantity = 0
              v.inventory_management = "shopify"
              v.inventory_policy = "deny"
          });

          var productJson = JSON.stringify(product)
          const handle = product.handle
          let type = 'solids'
          if (handle.indexOf('-prints') > -1 || handle.indexOf('-patterns') > -1) {
              type = 'prints'
          } else if (handle.indexOf('-contrasts') > -1) {
              type = 'contrasts'
          }
          if (!data[type]) {
              data[type] = {
                  handle: type,
                  // Uppercase the first letter:
                  name: type.charAt(0).toUpperCase() + type.substring(1),
                  swatches: {},
                  sizes: {},
              }
          }
          var sizeOptionKey = 'option1';
          var swatchOptionKey = 'option2';
          
          // Look up variant option keys
          product.options.forEach(opt => {
              if (opt.name === 'Color') {
                  swatchOptionKey = `option${opt.position}`
                  opt.values.forEach(val => {
                      if (!data[type].swatches[val]) {
                          data[type].swatches[val] = {
                              name: val,
                              available: false,
                              images: []
                          }    
                      }
                  })
              } else if (opt.name === 'Size') {
                  sizeOptionKey = `option${opt.position}`
                  opt.values.forEach(val => {
                      if (!data[type].sizes[val]) {
                          data[type].sizes[val] = {
                              name: val
                          }
                      }
                  })
              }
          })
          product.variants.forEach(variant => {
              const swatch = variant[swatchOptionKey]
              const size = variant[sizeOptionKey]
              variant.size = size
              variant.swatch = swatch
              variant.tab = type
              variant.oldPrice = variant.compare_at_price
              variant.product = product
              variant.productJson = productJson
              variant.isOnSale = (variant.compare_at_price && variant.compare_at_price !== variant.price) ? true : false;
              variants[`${swatch}-${size}`] = variant
              // we need to ignore swatches not avail
              if ((variant.available || isPreorder(variant.product)) && data[type].swatches[swatch]) {
                  //console.log('type', type, data[type], data[type].swatches[swatch])
                  data[type].swatches[swatch].available = true
              }
              if (variant.isOnSale && data[type].swatches[swatch]) {
                  data[type].swatches[swatch].isOnSale = true
              }
              if (variant?.product?.images?.length > 0) {
                variant.product.images.forEach(image => {
                  const filename = image.src;
                  const thumb = filename.substring(0, filename.lastIndexOf(".")) + "_160x" + filename.substring(filename.lastIndexOf("."));
                  const large = filename.substring(0, filename.lastIndexOf(".")) + "_1120x" + filename.substring(filename.lastIndexOf("."));
                  image.thumb = thumb;
                  image.large = large;
                  if (!data[type].swatches[swatch].images.some(image => image.thumb === thumb || image.large === large)) {
                    data[type].swatches[swatch].images.push(image);
                  }
                })
              }
              if (variant.featured_image && variant.featured_image.src && data[type].swatches[swatch]) {
                  if (data[type].swatches[swatch].images.filter(img => img.src === variant.featured_image.src).length === 0) {
                      var filename = variant.featured_image.src
                      variant.featured_image.thumb = filename.substring(0, filename.lastIndexOf(".")) + "_160x" + filename.substring(filename.lastIndexOf("."));
                      variant.featured_image.large = filename.substring(0, filename.lastIndexOf(".")) + "_1120x" + filename.substring(filename.lastIndexOf("."));                       
                      data[type].swatches[swatch].images.push(variant.featured_image)
                  }
              }
          });
      })
      
      // Check to see if there are empty tabs
      Object.keys(data).forEach(entry => {
          data[entry].available = false;
          Object.values(data[entry].swatches).forEach(sw => {
              if (sw.available) {
                  data[entry].available = true;
              }
          })
          // Delete any tabs that are entirely sold out
          if (!data[entry].available) {
              // delete variant reference
              Object.values(data[entry].sizes).forEach(size => {
                  Object.keys(data[entry].swatches).forEach(sw => {
                      if (variants[`${data[entry].swatches[sw].name}-${size.name}`]) {
                          delete variants[`${data[entry].swatches[sw].name}-${size.name}`];
                      }
                  });
              });
              // delete tab
              delete data[entry]
          }
      })
      
      callback({
          tabs: data,
          variants,
      })
  })
}

getExclusions() {
  const fetchExclusions = (page = 1, allProducts = []) => {
    return fetch(`/collections/sitewide-promotion-exclusions/products.json?limit=250&page=${page}`)
      .then(res => res.json())
      .then(data => {
        allProducts = allProducts.concat(data.products);
        if (data.products.length === 250) {
          return fetchExclusions(page + 1, allProducts);
        }
        this.exclusions = allProducts;
        return allProducts;
      });
  };

  return fetchExclusions();
}

getEcommerceExclusives() {
  const fetchExclusives = (page = 1, allProducts = []) => {
    return fetch(`/collections/ecommerce-exclusive/products.json?limit=250&page=${page}`)
      .then(res => res.json())
      .then(data => {
        allProducts = allProducts.concat(data.products);
        if (data.products.length === 250) {
          return fetchExclusives(page + 1, allProducts);
        }
        this.ecommerceExclusives = allProducts;
        return allProducts;
      });
  };

  return fetchExclusives();
}

markExclusion() {
  const excluded = this.exclusions.some(product => product.id === this.selectedVariant.product.id);
  if (excluded) {
      document.getElementById('promotion-exclusions-container').innerHTML = `<p style="color: red; font-size: .8rem; margin: 1rem 0 -.5rem 0;">Excluded from promotion</p>`;
  }
}

markEcommerceExclusive() {
  console.log('ecommerce exclusives', this.ecommerceExclusives, this.selectedVariant.product.id);
  const isExclusive = this.ecommerceExclusives.some(product => product.id === this.selectedVariant.product.id);
  if (isExclusive) {
    document.getElementById('ecommerce-exclusive-container').innerHTML = `<p style="color: #008A5E; font-size: .8rem; margin: 1rem 0 -.5rem 0;">Online exclusive</p>`;
  }
}

checkExclusions() {
  try {
    document.getElementById('promotion-exclusions-container').innerHTML = '';
    if (!this.exclusions) {
      this.getExclusions().then(() => {
       this.markExclusion();
      })
    } else {
      this.markExclusion();
    }
  } catch (e) {
    console.error(`Error checking exclusions: ${e}`);
  }
}

checkEcommerceExclusives() {
  try {
    document.getElementById('ecommerce-exclusive-container').innerHTML = '';
    if (!this.ecommerceExclusives) {
      this.getEcommerceExclusives().then(() => {
       this.markEcommerceExclusive();
      })
    } else {
      this.markEcommerceExclusive();
    }
  } catch (e) {
    console.error(`Error checking ecommerce exclusives: ${e}`);
  }
}

checkDelayedShipping() {
  try {
    document.getElementById('delayed-shipping-container').innerHTML = '';
    const tags = this.selectedVariant.product.tags;
    if (tags.includes('0425-delayed-shipping')) {
      document.getElementById('delayed-shipping-container').innerHTML = `<p style="color: red; font-size: .8rem; margin: 1rem 0 -.5rem 0;">Expected to ship by April 25th</p>`;
    }
  } catch (e) {
    console.error(`Error checking delayed shipping: ${e}`);
  }
}



checkBadges() {
  try {
    const badgeContainer = document.getElementById('product-badge-container');
    badgeContainer.innerHTML = '';
    const tags = this?.selectedVariant?.product?.tags;
    const badge = badges[tags?.find(tag => badges[tag])];
    if (badge) {
      badgeContainer.innerHTML = `
        <div class="product-badge" style="color: ${badge.color || 'inherit'}">
          ${badge.icon ? `<div class="product-badge-icon">${badge.icon}</div>` : ''}
          <div class="product-badge-label">${badge.label}</div>
        </div>
      `;
    }
  } catch (e) {
    console.error(`Error checking badges: ${e}`);
  }
}

adjustForPreorder() {
  $('.add-to-cart-button').show();
  $('.preorder-product').remove();
  if (!this.selectedVariant.available) {
    if (isPreorder(this.selectedVariant.product)) {
      $( "<div class='preorder-product out-of-stock promo_message_container'>This product is coming soon!</div>" ).insertBefore(document.querySelector('.variants-container'));
    }
    $('.add-to-cart-button').hide();
  }
}

setFabricContent() {
  try {
    setTimeout(() => {
      const fabricContainer = document.querySelector('.fabric-info');
      const imageContainers = fabricContainer.querySelectorAll('.fabric-image-container');
      const contentContainers = fabricContainer.querySelectorAll('.fabric-content-container');
      for (const imageContainer of imageContainers) {
        imageContainer.style.display = 'none';
      }
      for (const contentContainer of contentContainers) {
        contentContainer.style.display = 'none';
      }
      fabricContainer.style.display = 'none';
      const tags = this?.selectedVariant?.product?.tags;
      if (tags) {
        for (const tag of tags) {
          const els = fabricContainer.getElementsByClassName(tag);
          if (els.length > 0) {
            fabricContainer.style.display = 'grid';
            for (const el of els) {
              el.style.display = 'block';
            }
            break;
          }
        }
      }
    }, 0)
  } catch (e) {
    console.error(`Error setting fabric content: ${e}`);
  }
  
}

checkWishlist() {
  if (!window.WishlistKing?.customer) return;
  window.WishlistKing.loadWishlist({wishlistId: "mine"}).then(wishlist => {
    const variantId = this.selectedVariant.id;
    const items = wishlist?.items;
    const inWishlist = items?.some(item => item.variantId === variantId);
    document.querySelector('.wk-button-container button').classList.toggle("wk-selected", inWishlist);
  })
  
}

addListeners() {
  $(".product_form").on("keyup change paste", "input", () => {
    this.updateUrlAllowed = true;
    this.checkSwatches();
  });

  // Product QTY + - logic
  $(".qty .plus").click(function() {
      var qty = parseInt($(".qty-num").val());
      var newQty = qty + 1;
      $(".qty-num").val(newQty);
  });

  $(".notify-button").click(e => {
      if (!this.selectedVariant) {
          return;
      }
      window._BISConfig = window._BISConfig || {};
      var data = JSON.parse(this.selectedVariant.productJson)
      window._BISConfig.product = data
      window.BIS.init();
      setTimeout(() => {
          window.BISPopover.show({variantId: this.selectedVariant.id});
      }, 10);
  })

  $(".qty .minus").click(function() {
      var qty = parseInt($(".qty-num").val());
      qty--;
      if (qty < 1) {
          $(".qty-num").val(1);
      } else {
          $(".qty-num").val(qty);
      }
  });  

  $(".product_form").on("submit", e => {
    e.preventDefault();
    if (this.selectedVariant && this.selectedVariant.id) {
      var quantity = $("input[name='quantity']").val();
      this.ajaxPost(this.selectedVariant.id, quantity);
      $("input[name='quantity']").val(1);
    }
  });

  $(document).on("click", ".product__image__thumbs a", event => {
    event.preventDefault();

    var videoLoaded = $("video").length;
    if(videoLoaded) {
      $("video").each(function() {
        this.pause();
      });
    }

    if (this.currentCarousel) {
      this.currentCarousel.slideToLoop($(event.currentTarget).index());
    }
  });

  $(this.container)
    .find(".product_form")
    .attr("action", "/cart/add");

  $(".wk-button-container button").click(event => {
      event.preventDefault();
      if (!window.WishlistKing?.customer) return;
      window.WishlistKing.loadWishlist({wishlistId: "mine"}).then(wishlist => {
        const variantId = this.selectedVariant.id;
        const productHandle = this.selectedVariant.product.handle;
        const items = wishlist?.items;
        const wishlistItem = items?.find(item => item.variantId === variantId);
        event.currentTarget.classList.toggle("wk-selected", !wishlistItem);
        if (wishlistItem) {
          window.WishlistKing.removeWishlistItem({
            wishlistItemId: wishlistItem.id,
          });
        } else {
          window.WishlistKing.addWishlistItem({
            variantId,
            productHandle,
          });
        }
      })
    
  });
  $(window).resize(
    $.debounce(50, () => {
      this.resize();
    })
  );

  $(document)
    .on("click", "#desktop-carousel .swiper-wrapper img, #mobile-carousel .swiper-wrapper img", event => {
      event.preventDefault();
      this.positionZoomImage(event.offsetX, event.offsetY);
      this.activateZoomImage($(event.currentTarget).attr("src"));
    })
    .bind(this);

  $(".zoom-image").click(this.deactivateZoomImage);
  this.$zoomImage = $(".zoom-image");

  this.$zoomImage
    .mousemove(event => {
      this.positionZoomImage(event.offsetX, event.offsetY);
    })
    .bind(this);

  // Setup Details and Shipping Details accordions
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }

  // get current variant id
  var regex = new RegExp("[\\?&]variant=([^&#]*)");
  var results = regex.exec(location.search);
  if(results !== null) {
    var currentVariantId = decodeURIComponent(results[1].replace(/\+/g, " "));

    // Update variant_id input
    var variantIdInput = $('.variant_id');
    
    if (variantIdInput.length) {
      variantIdInput.val(currentVariantId);
    }

    // update fabric badge
    var fabricBadgeClass = '.surf-features_fabric--' + currentVariantId;
    $('.surf-features_fabric').hide();
    $(fabricBadgeClass).show();
    
    //reset inventory message
    var inventory_item = $('.inventory-container').find("[data-id='" + currentVariantId + "']");
    var inventoryDiv = $(inventory_item[0]).clone();
    $('.inventory-alternate').html(inventoryDiv);

    /**
    * update collection level promo message
    */

    // hide collection level promo bar
    $('.promo_message_container').hide();
    $('.promo_message_container .promo_message_1').hide();
    $('.promo_message_container .promo_message_2').hide();
    $('.promo_message_container .promo_message_3').hide();

    if(window.promoMessageArray[0].includes(currentVariantId)) {
      $('.promo_message_container .promo_message_1').show();
      $('.promo_message_container').show();
      console.log("YES");
    }

    if(window.promoMessageArray[1].includes(currentVariantId)) {
      $('.promo_message_container .promo_message_2').show();
      $('.promo_message_container').show();
    }

    if(window.promoMessageArray[2].includes(currentVariantId)) {
      $('.promo_message_container .promo_message_3').show();
      $('.promo_message_container').show();
    }

    /**
    * update child product level final sale badge
    */
    var isFinalSale = $('.final-sale-badge-data-wrapper').find("[data-id='" + currentVariantId + "']");
    isFinalSale = isFinalSale.data('final-sale') == true;

    if (isFinalSale) {
      $('.product-final-sale').show();
    } else {
      $('.product-final-sale').hide();
    }
  }

  // update inventory message when swatch changes
  $('body').on('change', '.swatch-element', () => {
    // get current variant id
    var regex = new RegExp("[\\?&]variant=([^&#]*)");
    var results = regex.exec(location.search);
    if(results !== null) {
      var currentVariantId = decodeURIComponent(results[1].replace(/\+/g, " "));

      // Update variant_id input
      var variantIdInput = $('.variant_id');
      
      if (variantIdInput.length) {
        variantIdInput.val(currentVariantId);
      }

      // update fabric badge
      var fabricBadgeClass = '.surf-features_fabric--' + currentVariantId;
      $('.surf-features_fabric').hide();
      $(fabricBadgeClass).show();
      
      // reset inventory message
      var inventory_item = $('.inventory-container').find("[data-id='" + currentVariantId + "']");
      var inventoryDiv = $(inventory_item[0]).clone();
      $('.inventory-alternate').html(inventoryDiv);

      /**
       * update collection level promo message
      */

      // hide collection level promo bar
      $('.promo_message_container').hide();
      $('.promo_message_container .promo_message_1').hide();
      $('.promo_message_container .promo_message_2').hide();
      $('.promo_message_container .promo_message_3').hide();

      if(window.promoMessageArray[0].includes(currentVariantId)) {
        $('.promo_message_container .promo_message_1').show();
        $('.promo_message_container').show();
        console.log("YES");
      }

      if(window.promoMessageArray[1].includes(currentVariantId)) {
        $('.promo_message_container .promo_message_2').show();
        $('.promo_message_container').show();
      }

      if(window.promoMessageArray[2].includes(currentVariantId)) {
        $('.promo_message_container .promo_message_3').show();
        $('.promo_message_container').show();
      }

      /**
      * update child product level final sale badge
      */
      var isFinalSale = $('.final-sale-badge-data-wrapper').find("[data-id='" + currentVariantId + "']");
      isFinalSale = isFinalSale.data('final-sale') == true;

      if (isFinalSale) {
        $('.product-final-sale').show();
      } else {
        $('.product-final-sale').hide();
      }
    }

    this.checkModelSizeFit();
    this.adjustForPreorder();
    this.checkExclusions();
    this.checkEcommerceExclusives();
    this.checkDelayedShipping();
    this.checkWishlist();
    this.setFabricContent();
    this.checkBadges();

    // update print collection
    var $selectedSwatchInput = $("input[name='color-input']:checked");
    var $selectedSwatchInputColor = $selectedSwatchInput.val();

    //---------remove print collection content
    $('.product-print-collection__wrapper').hide();
    $('.product-print-collection-body').owlCarousel('destroy');
    $('.product-print-collection-body').empty();

    if(window.print_products) {
      var print_product_limit = 4;
      var iterator = 1;

      //---------draw print collection content
      window.print_products.every(function(print_product) {
        if(iterator > print_product_limit) {
          return false;
        }
        
        print_product_slug = print_product.slug;

        print_product.variants.every(function(variant) {
          if(variant.option1 == $selectedSwatchInputColor && variant.id != currentVariantId) {
            iterator ++;

            var productLink = '/products/' + print_product_slug + '?variant=' + variant.id;

            $('.product-print-collection-body').append(`
              <div class="product-print-collection_item">
                <a href="${productLink}">
                  <div class="product-print-collection_item_image" style="background-image: url(${Shopify.resizeImage(variant.featured_image_src, "x200")})"></div>
                  
                  <div class="product-print-collection_item_content">
                    <div class="product-print-collection_item_title">
                      ${print_product.title}
                    </div>

                    <div class="product-print-collection_item_price">
                      ${Shopify.formatMoney(variant.price)}
                    </div>
                  </div>
                </a>
              </div>
            `);

            $('.product-print-collection__wrapper').show();

            return false;
          }

          return true;
        });

        return true;
      });

      var owlConfig = {
        items: 4,
        autoWidth: false,
        lazyLoad: true,
        loop: true,
        margin: 30,
        nav: true,
        dots: false,
        responsive: {
          0: {
            items: 1
          },
          375: {
            items: 2,
            margin: 60
          },
          767: {
            items: 3
          },
          992: {
            items: 4
          }
        }
      };

      $('.product-print-collection-body').owlCarousel(owlConfig);
    }
  });
}

checkModelSizeFit() {
  try {
    const header = document.querySelector('#model-size-fit-header');
    const content = document.querySelector('#model-size-fit-content');
    content.innerHTML = '';
    header.style.display = 'none';
    content.style.display = 'none';
    const storefrontAccessToken = 'd9957d4f65657f2b7e9954866327c71f';
  
    const query = `{
      product(id: "gid://shopify/Product/${this.selectedVariant.product.id}") {
        metafield(namespace: "global", key: "model_info") {
          key
          value
        }
      }
    }`;
  
    fetch(`https://jolyn-clothing-company-usa.myshopify.com/api/2024-01/graphql.json`, {
      method: 'POST',
      headers: {
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query })
    })
    .then(response => response.json())
    .then(data => {
      const modelInfo = data.data.product.metafield.value;
      if (modelInfo) {
          setTimeout(() => {
            content.innerHTML = modelInfo.replace(/\n/g, '<br>');
            header.style.display = 'block';
          }, 0);
      }
    });
  } catch (error) {
    console.error('Error checking model size fit:', error);
  }
}

resize() {
  const $carousel = $(".product__image");
  var vpWidth = $(window).width();
  if (vpWidth > 767) {
    $carousel.appendTo($("#desktop-carousel .carousel-container"));
  } else {
    $carousel.appendTo($("#mobile-carousel .carousel-container"));
  }
}

map(input, in_min, in_max, out_min, out_max) {
  return (
    ((input - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
  );
}

positionZoomImage(x, y) {
  const maxX = this.$zoomImage.innerWidth();
  const maxY = this.$zoomImage.innerHeight();
  let scaledX = this.map(x, 0, maxX, 0, 100);
  let scaledY = this.map(y, 0, maxY, 0, 100);
  this.$zoomImage.css({
    "background-position": `${scaledX}% ${scaledY}%`
  });
}
activateZoomImage(url) {
  $(".zoom-image")
    .css({
      "pointer-events": "auto",
      opacity: 1,
      "background-image": `url('${url}')`
    })
    .mousemove();
}

deactivateZoomImage() {
  $(".zoom-image")
    .css({
      "pointer-events": "none",
      opacity: 0
    })
    .mousemove();
}

buildVariantMap(variantJson) {
  var flatVariants = variantJson.flat(2);
  var variantIds = [
    ...new Set(flatVariants.map(variant => variant.variantId))
  ];

  return (variantMap = variantIds.map(variant => {
    let values = flatVariants.filter(e => e.variantId == variant);
    return {
      size: values[0].size,
      color: values[1].color,
      image: values[0].image,
      price: values[0].price,
      available: values[0].available === "true",
      oldPrice: values[0].oldPrice,
      isOnSale: values[0].isOnSale === "true",
      variant
    };
  }));
}

addSwatchesToContainer(colorTabIdList) {
  colorTabIdList.forEach(function(id) {
    $(`[swatch-color-tab="${id}"]`)
      .detach()
      .appendTo(`[color-tab-id="${id}"]`);
  });
  $(".swatch-element.size")
    .detach()
    .appendTo(".size-list");
}

setImgThumbs(imgObjs, color) {
  $(".img-slide.all_thumb").hide();
  // $(`.img-slide.all_thumb:lt(${imgObjs.length})`).css("display", "block");
  if (color) {
    color = this.getSwatchSlug(color);
    $(`.img-slide.all_thumb.${color}`).css("display", "block");
  }
}

listCategories() {
  var categories = [];
  $(".color-swatch__tab-opener").each(function(i, item) {
    categories.push(
      $(item)
        .text()
        .replace(/ /g, "")
        .replace(/(?:\r\n|\r|\n)/g, "")
    );
  });
  var phrase = categories
    .reduce(function(prev, curr, i) {
      return prev + curr + (i === categories.length - 2 ? " or " : ", ");
    }, "")
    .slice(0, -2);
  $(".color-swatch__tab-header").text("Select: " + phrase);
}

showTeammatesFlag(){
    if (!this.selectedVariant) {
      return;
    }
    var product_tags = this.selectedVariant.product.tags;
    if ($.inArray('teammates-collection', product_tags) != -1)
    {
       $('#teammates-badge').css('display','inline-flex');
    }else{
      $('#teammates-badge').css('display','none');
    }
  } 

updateCarousel(swatch) {
  if (!this.selectedVariant) {
      return;
  }
  
  var swatch = this.tabs[this.selectedVariant.tab].swatches[this.selectedVariant.swatch];
  var swatchImages = swatch.images;

  if (this.currentCarousel && this.currentCarousel.destroy) {
    this.currentCarousel.destroy(true, true);
  }

  $(".product__image__photos").attr(
    "style",
    `width: ${$(".product__image__photos").width()}px`
  );
  $(".product__image__thumbs").empty();
  $(".product__image__photos").empty();
  $(".product__image__photos").append(
    $('<div class="swiper-wrapper"></div>')
  );
  $(".product-button-prev").hide();
  $(".product-button-next").hide();

  swatchImages.forEach(img => {
     if (swatchImages.length > 1){
      $(".product__image__thumbs").append(
        $(
          `<a href="#" aria-label="Jump to image">
            <img src="${img.thumb}" alt="${img.color}">
          </a>`
        )
      );
    }

    $(".swiper-wrapper").append(
      $(
        `<div class="swiper-slide product__image__photos--slide">
          <img src="${img.large}" class="" fetchpriority="high" alt="${this.selectedVariant.product.title}">
        </div>`
      )
    );
  });

  var variant_image_message_selector = $(".variant_metafield[data-variant-id=" + this.selectedVariant.id + "] span");
  var variant_image_message = '';

  if (variant_image_message_selector.length > 0) {
    variant_image_message = variant_image_message_selector[0].innerText;
  }

  $('.variant_image_message').text( variant_image_message);

  var productID = this.selectedVariant.product.id;
  var productMetafield = $(".product_metafields").find("[data-product-id=" + productID + "]");
  
  if(productMetafield.length > 0) {
    var productVideoThumbnail = $($(productMetafield[0]).find(".product_metafield__video_thumbnail")[0]).data("video-thumbnail");
    var productVideoUrl = $($(productMetafield[0]).find(".product_metafield__video_url")[0]).data("video-url");
    var productVideoModel = $(productMetafield[0]).find(".product_metafield__video_model")[0];
    $(".product__image__thumbs").append($("<a href=\"#\" aria-label=\"Jump to image\"><img\n            src=\"".concat(productVideoThumbnail, "\" alt=\"").concat("\"><svg width='30pt' height='30pt' version='1.1' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg' style='position: absolute; left: 20px; bottom: 40px; fill: #fff;'><path d='m50 12c-20.988 0-38 17.012-38 38s17.012 38 38 38 38-17.012 38-38-17.012-38-38-38zm-11 20l30 18-30 18z'></path></svg></a>")));
    if(productVideoModel) {
      productVideoModel = productVideoModel.innerText;
      $(".swiper-wrapper").append($("<div class=\"swiper-slide product__image__photos--slide\"><video controls preload=\"none\" style=\"width:100%; cursor: default;\" poster=\"".concat(productVideoThumbnail, "\"><source src=\"".concat(productVideoUrl, "\" type='video/mp4' /></video><div style=\"font-size: 12px; cursor: default; text-align: center;\">" + productVideoModel + "</span></div>"))));
    } else {
      $(".swiper-wrapper").append($("<video controls preload=\"none\" class=\"swiper-slide product__image__photos--slide\" style=\"width:100%; cursor: default; text-align: centerl;\" poster=\"".concat(productVideoThumbnail, "\"><source src=\"".concat(productVideoUrl, "\" type='video/mp4' /></video>"))));
    }
  }

  this.currentCarousel = new Swiper(".product__image__photos", {
    // autoHeight: true, can't use with first image being lazyloaded
    slidesPerView: 1,
    speed: 500,
    loop: (swatchImages.length > 0) ? true : false,
    direction: "horizontal",
    navigation: {
      nextEl: ".product-button-next",
      prevEl: ".product-button-prev"
    },
    pagination: {
      el: ".product-pagination",
      type: 'bullets',
    },
    on: {
      imagesReady: () => {
        this.loadPlugins();
        $(".product-template-alt").css({ opacity: 1 });
        if (swatchImages.length > 1) {
          $(".product-button-prev").show();
          $(".product-button-next").show();
          $(".product-pagination").show();
        }
        $(".product__image__photos").attr("style", "");
        if (this.currentCarousel && this.currentCarousel.update) {
          this.currentCarousel.update();
        }
      }
    }
  });
  setTimeout(() => {
    if (this.currentCarousel && this.currentCarousel.update) {
      this.currentCarousel.update();
    } else {
      setTimeout(() => {
        this.currentCarousel.update();
      }, 1500);
    }
  }, 300);
  //$('.product__image__photos').css({ width: null });

  // pairswith app
  $.ajax({
    method: 'GET',
    url: 'https://pairswith.app/products/getImages?variant_id=' + this.selectedVariant.id
  }).then(function (res) {
    metafields = res.images;
    direction = res.position_flag;
    var handles = res.handles;
    var prices = res.prices;
    var titles = res.titles;
  
    if (metafields.length != 0) {
      var image_add = metafields.split(",");
      var handle_add = handles.split(",");
      var price_add = prices.split(",");
      var title_add = titles.split(",");
  
      if (direction == 1) {
        $("#top-image").empty();
        $("#top-image").append($("<img src=\"".concat(swatchImages[0].medium, "\" class=\"swiper-slide product__image__photos--slide\" alt=\"").concat(swatchImages[0].color, "\"><div class=\"current-product\">This product</div>")));
      } else {
        $("#bottom-image").empty();
        $("#bottom-image").append($("<img src=\"".concat(swatchImages[0].large, "\" class=\"swiper-slide product__image__photos--slide\" alt=\"").concat(swatchImages[0].color, "\"><div class=\"current-product\">This product</div>")));
      }
  
      $('#slideshow .slick').slick('unslick');
      $('#slideshow .slick').empty();
  
      for (var i = 0; i < image_add.length; i++) {
        $('#slideshow .slick').append($("<div><a href='/products/" + handle_add[i] + "'><img src='" + image_add[i] + "' ><div class=\"product-info\"><p class=\"product-name\">" + title_add[i] + "</p><p class=\"product-price\">$" + price_add[i] + "</p></div></a></div>"));
      }
  
      $('#slideshow .slick').slick();
    } else {
      $('#slideshow .slick').slick('unslick');
      $('#slideshow .slick').empty();
      $("#top-image").empty();
      $("#bottom-image").empty();
    }
  });
}

getUrlParameter(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}

/**
 *  Get element from variantMap
 */
findElement(size, color, variantMap) {
  return variantMap.find(function(element) {
    return element["size"] == size && element["color"] == color;
  });
}

findElementBySwatch(color, variantMap) {
  return variantMap.find(function(element) {
    return element["color"] == color;
  });
}

findSwatchSizes(color, variantMap) {
  return variantMap.filter(function(element) {
    return element["color"] == color;
  });
}

findParentTabName(variantId) {
  var tabName;
  var variantId = parseInt(variantId, 10);
  for (var key in productParentProductData) {
    if (productParentProductData.hasOwnProperty(key)) {
      productParentProductData[key].variants.forEach(varient => {
        if (varient.id === variantId) {
          tabName = key;
        }
      });
    }
  }
  return tabName
}

findColorElements(color, variantMap) {
  var objs = [];

  variantMap.map(function(element) {
    if (element["color"] == color) {
      objs.push(element);
    }
  });

  var images = [...new Set(objs.map(variant => variant.image))];

  return images;
}

ajaxPost(id, quantity) {
  var a = $(this);
  $.ajax({
    type: "POST",
    url: "/cart/add.js", // Send the login info to this page
    data: {
      quantity: "" + quantity,
      id: "" + id
    },
    dataType: "jsonp",
    timeout: 200000,
    error: function(t) {
      console.log("error", t);
      Shopify.getCart(function(e) {
        let box = $("#cart-box");
        box.find(".product-link").attr("href", t.url),
          box
            .find(".product-img")
            .attr("src", Shopify.resizeImage(t.image, "medium"))
            .attr("alt", ""),
          box.find(".product-title .product-link").html("title"),
          box
            .find(".product-price")
            .html(Shopify.formatMoney(t.price, money_format)),
          //          frontendData.enableCurrency && currenciesCallbackSpecial("#cart-box span.money");
          setTimeout(function() {
            $(".loader-container").hide();
            $("#resultLoading").hide();
            // box.addClass("show");
            // $(".mini-cart .cart-wrapper").show("show");
            // setTimeout(function() {
            //   box.removeClass("show");
            //   $(".mini-cart .cart-wrapper").hide("show");
            // }, 5e3); 
          }, 500),
          SW.collection.updateCartInfo(
            e,
            ".cart-container .cart-wrapper .cart-inner-content"
          );
      });
      return false;
    },

    success: function(t) {
      Shopify.getCart(function(e) {
        let box = $("#cart-box");
        box.find(".product-link").attr("href", t.url),
          box
            .find(".product-img")
            .attr("src", Shopify.resizeImage(t.image, "medium"))
            .attr("alt", ""),
          box.find(".product-title .product-link").html("title"),
          box
            .find(".product-price")
            .html(Shopify.formatMoney(t.price, money_format)),
          //          frontendData.enableCurrency && currenciesCallbackSpecial("#cart-box span.money");
          setTimeout(function() {
            $(".loader-container").hide();
            $("#resultLoading").hide();
            //box.addClass("show");
            //$(".mini-cart .cart-wrapper").show("show");
            //setTimeout(function() {
            //  box.removeClass("show");
            //  $(".mini-cart .cart-wrapper").hide("show");
            //}, 5e3);
          }, 500),
          SW.collection.updateCartInfo(
            e,
            ".cart-container .cart-wrapper .cart-inner-content"
          );

          maestra("async", {
            operation: "SetCart",
            data: Object.assign(
              {},
              window.loggedInCustomerEmail ? {
                customer: {
                  email: window.loggedInCustomerEmail
                }
              } : {},
              {
                productList: e.items.map(function(product) {
                  return {
                    product: {
                      ids: {
                        shopifyid: product.id
                      }
                    },
                    count: product.quantity,
                    pricePerItem: product.price
                  };
                })
              }
            ),
            onSuccess: function() {},
            onError: function(error) {
              console.log(error);
            }
          });
      });
      return false;
    }
  });
}

openTab(tabName, clickFirstSwatch) {
  var $tabOpeners = $(".color-swatch__tab-opener");
  var $tab = $(`[color-tab-opener="${tabName}"]`)
  var $tabVariantContainers = $(".variants-container.color-list");
  var $thisTabVariantContainer = $(`[color-tab-id="${tabName}"]`); //current color grouping
  if (clickFirstSwatch) {
    var $firstLabel = $thisTabVariantContainer
      .find("li")
      .first()
      .find("label");
    $firstLabel.click();      
  }
  $tabOpeners.attr("aria-pressed", false);
  $tabOpeners.removeClass("active"); // Make all tabs inactive
  $tab.addClass("active"); // Make clicked on tab active
  $tab.attr("aria-pressed", true);
  $tabVariantContainers.hide(); // Make all containers inactive
  $thisTabVariantContainer.css('display', 'flex'); // Make current grouping container active
}

getSwatchSlug(swatchName) {
  let updated = swatchName
    .toLowerCase()
    .replace(/ & /g, " ")
    .replace(/&/g, " ");
  updated.replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  return updated.replace(/\//g, "-").replace(/ /g, "-");
}


additionalSetupRefactorThis() {

  var owlConfig = {
    items: 4,
    autoWidth: false,
    lazyLoad: true,
    loop: true,
    margin: 30,
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1
      },
      375: {
        items: 2,
        margin: 20
      },
      767: {
        items: 3
      },
      992: {
        items: 4
      }
    }
  };

  waitForEl(
    ".you-may-also-like .recommendify-panel-body",
    function() {
      $(".you-may-also-like .recommendify-panel-body").owlCarousel(owlConfig);
    },
    20,
    200
  );

  waitForEl(
    ".recently-viewed .recommendify-panel-body",
    function() {
      $(".recently-viewed .recommendify-panel-body").owlCarousel(owlConfig);
    },
    20,
    200
  );
}

loadPlugins() {
    if (!this.pluginsLoaded) {
      this.pluginsLoaded = true;
      this.additionalSetupRefactorThis();
    }
}

getSaleLabel(price, oldPrice) {
  return $(`<dl class="price price--on-sale" data-price="">
  <div class="price__regular"> 
    <dt>
      <span class="visually-hidden visually-hidden--inline">Regular price</span>
    </dt>
    <dd>
      <span class="price-item price-item--regular" data-regular-price="${oldPrice}">
            ${oldPrice}
      </span>
    </dd>
  </div>
  <div class="price__sale">
    <dt>
      <span class="visually-hidden visually-hidden--inline">Sale price</span>
    </dt>
    <dd>
      <span class="price-item price-item--sale" data-sale-price="${price}">
        ${price}
      </span>
      <span class="price-item__label" aria-hidden="true">Sale</span>
    </dd>
  </div>
</dl>`);
}
}
window.addEventListener('DOMContentLoaded', (event) => {
  //normal product page guard clause
  const targetNode = document.querySelector('body.template-product')
  if (!targetNode) return
  // Review Stars Don't Display on Eryn Products #249
  const showStars = function(mutationsList, observer) {
    let isLoaded = false
    for(const mutation of mutationsList) {
        if (mutation.type !== 'childList') return 
    }
  };

  const observer = new MutationObserver(showStars);
  observer.observe(targetNode, { childList: true, subtree: true });

      //fix for BIS when color changed
      Array.from(document.querySelector('.color-list.swatch').children).forEach(el=> el.addEventListener('click', function(e) {
        document.querySelector('.header.color span').textContent = this.dataset.value
       })
     )

});

// window.addEventListener('load', (event) => {
//     //normal product page guard clause
//   const productPage = document.querySelector('body.template-product')
//   if (!productPage) return

//   const availSizes = document.querySelectorAll('#size-container .swatch-element:not(.soldout) input')
//   let availSwatches;
//   let isAvailProductSelected = false
//   for (var i = 0; i < availSizes.length; i++ ) {
//     availSizes[i].click()
//     //new first swatch
//     availSwatches = document.querySelectorAll('#swatch-container .swatch-element:not(.currently-unavailable) input')
//     if(availSwatches) {
//       for (let i=0; i < availSwatches.length -1; i++ ) {
//         availSwatches[i].click()
//         isAvailProductSelected = true
//         break;
//       }
//     } else console.log('no swatches for this size')
//     if (isAvailProductSelected) break;     
//   }


// })

const container = document.querySelector(".product-template-alt");
if (container) {
new ProductParent(container);
}
